import { _t } from "../../services/TranslationService.js";

let About = {
    render : async () => {
        let view =  /*html*/`
            <section class="section">
                <h1> ${_t('Rreth Nesh')} </h1>
            </section>
        `
        return view
    },
    after_render: async () => {}
}

export default About;